import { useEffect, useState } from "react"
import { useTranslation } from 'hooks/useTranslation'
import { useRouter } from "hooks/useRouter"
import { useAddToCart } from "features/ECommerce/hooks/useAddToCart"
import { useFetchProductVariantDetail } from "features/ECommerce/api/queries/useFetchProductVariantDetail"
import { isElementVisible } from "utils/dom"
import { Loader } from "features/components/Loader"
import heroChicken from '../../../../../../public/assets/product/5lb-chicken-hero.webp'
import heroBeef from '../../../../../../public/assets/product/5lb-beef-hero.webp'
import heroLamb from '../../../../../../public/assets/product/5lb-lamb-hero.webp'
import heroDuck from '../../../../../../public/assets/product/5lb-duck-hero.webp'
import heroVenison from '../../../../../../public/assets/product/5lb-venison-hero.webp'
import heroTurkey from '../../../../../../public/assets/product/5lb-turkey-hero.webp'
import { FivePoundRoot } from "./FivePound.styles"
import { Layout } from "components/Layout"
import { Header } from "components/Header"
import { Hero } from "./components/Hero"
import { Ingredients } from "./components/Ingredients"
import { SafetyQuality } from "./components/SafetyQuality"
import { FeedingGuidelines } from "./components/FeedingGuidelines"
import { CustomMealPlan } from "./components/CustomMealPlan"
import { EssentialBox } from "./components/EssentialBox"
import { Compare } from "features/Recipes/components/Compare"
import { Reviews } from "features/Recipes/components/Reviews"
import { Spacer } from "features/Recipes/Recipes.styles"
import { RecipeFooter } from "features/Recipes/components/RecipeFooter"
import { Footer } from "components/Footer"
import { getProteinFromSlug } from "utils/getProteinFromSlug"
import { IngredientType } from "../Essentials/components/OurIngredients/OurIngredients"
import { ProductReviewType } from "fixtures/review"
import { StaticImageData } from "next/image"
import { Proteins } from "models/Pet"
import { ProductTypes } from "models/Product"
import { useFetchProductVariants } from "features/ECommerce/api/queries/useFetchProductVariants"
import { useFetchShoppingCart } from "features/ECommerce/api/queries/useFetchShoppingCart"
import { ProductPageReviews } from "fixtures/review"
import { IngredientMap } from "./components/Ingredients/Ingredients"
import chickenBadge from '../../../../../../public/assets/recipes/categories/individual/chicken-badge.webp'
import beefBadge from '../../../../../../public/assets/recipes/categories/individual/beef-badge.webp'
import duckBadge from '../../../../../../public/assets/recipes/categories/individual/duck-badge.webp'
import venisonBadge from '../../../../../../public/assets/recipes/categories/individual/venison-badge.webp'
import turkeyBadge from '../../../../../../public/assets/recipes/categories/individual/turkey-badge.webp'
import lambBadge from '../../../../../../public/assets/recipes/categories/individual/lamb-badge.webp'

const {
  venison,
  beefHeart,
  beefLiver,
  beefKidney,
  beefBone,
  vitamin,
  chickenHeart,
  chickenBacks,
  chickenLegs,
  chickenLiver,
  turkeyGizzards,
  turkeyTails,
  turkeyWings,
  turkeyLiver,
  lamb,
  duck,
} = IngredientMap

const {
  julie,
  cristin,
  barbara,
  autumn,
  diana,
  lori,
  nena,
  ashley,
  rachel,
  rebekah,
  seth,
  norman,
  peter,
  darlene,
  jen,
  mallia,
  jev,
  teresa,
} = ProductPageReviews

export const Recipes = {
  [Proteins.CHICKEN]: {
    heroThumb: heroChicken,
    badge: chickenBadge,
    ingredients: [chickenHeart, chickenBacks, chickenLegs, chickenLiver, vitamin],
    reviews: [julie, cristin, barbara],
  },
  [Proteins.BEEF]: {
    heroThumb: heroBeef,
    badge: beefBadge,
    ingredients: [beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [mallia, jev, teresa],
  },
  [Proteins.VENISON]: {
    heroThumb: heroVenison,
    badge: venisonBadge,
    ingredients: [venison, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [autumn, diana, lori],
  },
  [Proteins.DUCK]: {
    heroThumb: heroDuck,
    badge: duckBadge,
    ingredients: [duck, turkeyGizzards, turkeyTails, turkeyLiver, vitamin],
    reviews: [nena, ashley, rachel],
  },
  [Proteins.TURKEY]: {
    heroThumb: heroTurkey,
    badge: turkeyBadge,
    ingredients: [turkeyTails, turkeyGizzards, turkeyWings, turkeyLiver, vitamin],
    reviews: [peter, darlene, jen],
  },
  [Proteins.LAMB]: {
    heroThumb: heroLamb,
    badge: lambBadge,
    ingredients: [lamb, beefHeart, beefLiver, beefKidney, beefBone, vitamin],
    reviews: [rebekah, seth, norman],
  },
}

export const FivePound = () => {

    const { t } = useTranslation()
    const { query } = useRouter()
    const addToCart = useAddToCart()
    const header = <Header />

    const thumbnailOptions: Record<Proteins, StaticImageData> = {
      [Proteins.CHICKEN]: heroChicken,
      [Proteins.BEEF]: heroBeef,
      [Proteins.TURKEY]: heroTurkey,
      [Proteins.DUCK]: heroDuck,
      [Proteins.LAMB]: heroLamb,
      [Proteins.VENISON]: heroVenison
    }

    const { productId } = query as { productId: string }
    const { data: productDetail, status: statusDetail } = useFetchProductVariantDetail(productId)
    const { data: shoppingCart, status: statusCart } = useFetchShoppingCart({})

    const [typesFilter, setTypesFilter] = useState<ProductTypes[]>([])
    const [proteinsFilter, setProteinsFilter] = useState<Proteins[]>([])
    const [querySearch, setQuerySearch] = useState('box')

    const { data: boxes, status: statusBoxes } = useFetchProductVariants(
      {
        page: 1,
        limit: 10,
        proteins: proteinsFilter,
        types: typesFilter,
        textSearch: querySearch,
      },
      { keepPreviousData: true }
    )

    const [isHidden, setIsHidden] = useState(true)

    const protein = getProteinFromSlug(productId)


    useEffect(() => {
      const _scrollListener = () => {
        setIsHidden(false)

        const isCTAVisible = isElementVisible('.product-cta')
        const isFooterVisible = isElementVisible('.footer')

        if (isCTAVisible || isFooterVisible) {
          setIsHidden(true)
        }
      }
      document.addEventListener('scroll', _scrollListener)

      return () => document.removeEventListener('scroll', _scrollListener)
    })

    if (!protein) return <Loader />
    if (statusDetail === 'loading' || statusDetail === 'idle' || statusDetail === 'error') return <Loader />
    if (statusBoxes === 'loading' || statusBoxes === 'idle' || statusBoxes === 'error') return <Loader />
    if (statusCart === 'loading' || statusCart === 'error') return <Loader />

    const ingredients: IngredientType[] = Recipes[protein].ingredients
    const reviews: ProductReviewType[] = Recipes[protein].reviews
    const thumbnail: StaticImageData = thumbnailOptions[protein]

    const isOutOfStock = productDetail.isHidden

 return (
    <FivePoundRoot>
      <Layout hideCTA header={header}>
        <Hero shoppingCart={shoppingCart} onAdd={addToCart} product={productDetail} recipe={protein} thumbnail={thumbnail} />
        <Ingredients background="accent-white" hideWave recipe={protein} ingredients={ingredients} />
        <SafetyQuality />
        <FeedingGuidelines />
        <CustomMealPlan />
        <EssentialBox onAdd={addToCart} data={boxes} />
        <Compare background="tertiary-200" />
        <Spacer />
        <Reviews icon cardColor="tertiary-200" background="accent-white" reviews={reviews}/>
        <RecipeFooter ctaLink='/meal-plan' cta={t('products:footer.cta1')} header={t('products:footer.title')}  />
        <Footer />
      </Layout>
    </FivePoundRoot>
 )
}
